import { FC } from 'react';
import { Link, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) =>
  createStyles({
    grecaptcha: {
      display: 'flex',
      flexFlow: 'row wrap',
      justifyContent: 'center',
      marginTop: '12px',
      color: '#7f7f7f',
      fontSize: '12px',
      textAlign: 'center',
      '& .MuiLink-root': {
        color: '#1565c0',
      },
    },
  }),
);

export const GrecaptchaTypography: FC = () => {
  const classes = useStyles();

  return (
    <Typography className={classes.grecaptcha}>
      <span>このサイトはreCAPTCHAによって保護されており、</span>
      <span>
        Googleの
        <Link
          href="https://policies.google.com/privacy"
          target={'_blank'}
          rel={'noreferrer'}
        >
          プライバシーポリシー
        </Link>
        と
        <Link
          href="https://policies.google.com/terms"
          target={'_blank'}
          rel={'noreferrer'}
        >
          利用規約
        </Link>
        が適用されます。
      </span>
    </Typography>
  );
};
